import { FC } from "react";
import { MobileWrapper } from "./mobile.styled";
import { ASSETS_PATH } from "@dashboard/constants/constants";
import { useTranslation } from "react-i18next";
import QRCode from "react-qr-code";
import { MOBILE_APP_STORE_LINKS } from "@dashboard/modules/mobile/constants/mobile-app-store-links";

const Mobile: FC = () => {
  const { t } = useTranslation();
  const { android, ios } = MOBILE_APP_STORE_LINKS;

  return (
    <MobileWrapper>
      <div className="main-content">
        <div className="title">{t("mobile.title")}</div>
        <ul className="benefits">
          <li>{t("mobile.benefit1")}</li>
          <li>{t("mobile.benefit2")}</li>
          <li>{t("mobile.benefit3")}</li>
        </ul>
        <div className="qr-row">
          <div className="qr-box">
            <QRCode
              size={100}
              value={android.url}
              viewBox="0 0 80 80"
            />
            <div className="qr-label">{t("mobile.qrAndroidLabel")}</div>
            <button
              type="button"
              className="store-badge-btn"
              onClick={() => window.open(android.url, "_blank", "noopener,noreferrer")}
            >
              <img
                src={`${ASSETS_PATH}/web/android.webp`}
                alt={t("mobile.qrAndroidLabel")}
              />
            </button>
          </div>
          <div className="qr-box">
            <QRCode size={100} value={ios.url} viewBox="0 0 80 80" />
            <div className="qr-label">{t("mobile.qrIosLabel")}</div>
            <button
              type="button"
              className="store-badge-btn"
              onClick={() => window.open(ios.url, "_blank", "noopener,noreferrer")}
            >
              <img
                src={`${ASSETS_PATH}/web/ios.webp`}
                alt={t("mobile.qrIosLabel")}
              />
            </button>
          </div>
        </div>
      </div>
      <div className="right">
        <img
          src={`${ASSETS_PATH}/web/sumerweb-download-app-section-bg.webp`}
          alt=""
          className="bg"
        />
        <img
          src={`${ASSETS_PATH}/web/sumerweb-download-app-section-bg-3.webp`}
          alt=""
          className="bg bg2"
        />
      </div>
    </MobileWrapper>
  );
};

export default Mobile;
